// 電話號碼統一以 E.164 格式儲存：+{國碼}{號碼}
// 例：+886912345678、+81901234567

/**
 * formatPhoneInput — 保留相容性，用於搜尋場景（不做格式化）
 * 新的輸入元件（PhoneInput）已直接產出 E.164 格式
 */
export const formatPhoneInput = (value = '') => String(value ?? '').trim();

/**
 * normalizeMobileInput — 保留相容性
 */
export const normalizeMobileInput = (value = '') => String(value ?? '').trim();

/**
 * 格式化顯示："+886912345678" → "+886 912345678"
 */
export const formatPhoneDisplay = (phone) => {
  if (!phone || typeof phone !== 'string') return '';
  const trimmed = phone.replace(/\s/g, '');
  if (!trimmed.startsWith('+')) return trimmed;
  const digits = trimmed.slice(1);

  const CODES = ['886','852','853','81','82','86','65','66','60','84','63','62','91','61','64','44','49','33','1'];
  for (let len = 3; len >= 1; len--) {
    const prefix = digits.slice(0, len);
    if (CODES.includes(prefix)) {
      return `+${prefix} ${digits.slice(len)}`;
    }
  }
  return trimmed;
};

export const PHONE_INPUT_HINT = '選擇國碼 + 輸入電話號碼';
